{
    "edit": "Edit",
    "attachment": "Attachment",
    "backToSmartform": "Back to Smartform",
    "predefined": "Predefined",
    "library": "Library",
    "preview": "Preview",
    "previewPDF": "Preview PDF",
    "previewHTML": "Preview HTML",
    "pdfPreview": "PDF Preview",
    "htmlPreview": "HTML Preview",
    "splitScreen": "Split Screen",
    "singleScreen": "Single Screen",
    "refresh": "Refresh",
    "refreshWithLatest": "Refresh with latest changes",
    "refreshDisabled": "There are no changes to refresh",
    "loading": "Loading",
    "publish": "Publish",
    "discard": "Discard",
    "previous": "Previous",
    "next": "Next",
    "ok": "OK",
    "cancel": "Cancel",
    "delete": "Delete",
    "openMenu": "Open menu",
    "retry": "Retry",
    "exit": "Exit",
    "reason": "Reason",
    "moreoptions": "More options",
    "pageBreak": "Page Break",
    "addPageBreak": "Add page break",
    "addPageBreakBefore": "Add page break before",
    "addPageBreakAfter": "Add page break after",
    "removePageBreak": "Remove page break",
    "removePageBreakBefore": "Remove page break before",
    "removePageBreakAfter": "Remove page break after",
    "blockHelpText": "Press Shift + F10 or right-click for options",
    "paste": "Paste",
    "selectenoption": "Select en option",
    "none": "None",
    "authentication": {
        "authenticate": "Authenticate",
        "authenticationRequired": "Authentication Required",
        "forbidden": "Forbidden",
        "authenticateMessage": "This document is protected and requires users to authenticate.",
        "authFailedMessage": "If this problem persist please contact your system administrator"
    },
    "format": {
        "bold": "Bold",
        "italic": "Italic",
        "underline": "Underline",
        "alignment": "Alignment",
        "alignLeft": "Align Left",
        "alignCenter": "Align Center",
        "alignRight": "Align Right",
        "alignJustify": "Align Justify",
        "list": "List",
        "bulletedList": "Bulleted List",
        "numberedList": "Numbered List",
        "font": "Font",
        "size": "Size",
        "fontSize": "Font Size",
        "openFormatMenu": "Open format menu",
        "undo": "Undo",
        "redo": "Redo"
    }
}